<template>
    <div class="shop-filter-field" :class="{'shop-filter-field--compact': compact}">
        <label v-if="!compact" class="shop-filter-label">{{ formField.title }}</label>

        <vue-google-autocomplete
            :id="'filter-address-' + formField.id"
            classname="shop-filter-input"
            types="(cities)"
            :value="value"
            v-on:inputChange="clearHandler($event)"
            :placeholder="formField.title"
            v-on:placechanged="handleOnChange"
        />
        <input
            type="text"
            class="shop-filter-input mt-2"
            :placeholder="unitNumberLabel"
            :value="unitNumberValue"
            @input="onUnitNumberInput"
            autocomplete="off"
        >
    </div>
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: 'Address',
    components: { VueGoogleAutocomplete },

    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: '',
            unitNumberValue: '',
        }
    },

    computed: {
        unitNumberKey() {
            return this.formField.unit_number_key ?? `${this.formField.slug}_unit_number`;
        },
        unitNumberLabel() {
            return this.formField.unit_number_label ?? 'Unit number';
        },
        selectedFilters() {
            try {
                const search = location.search.substring(1);

                return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
            } catch (e) {
                return {};
            }
        },
    },

    methods: {
        handleOnChange(_, addressData) {
            this.value = addressData.formatted_address;

            this.onChangeHandler(`additional_data[${this.formField.slug}]`, this.value, false);
            this.onChangeHandler(`additional_data[${this.unitNumberKey}]`, this.unitNumberValue, true);
        },
        clearHandler(data) {
            if (data.newVal) {
                return;
            }

            this.value = '';
            this.onChangeHandler(`additional_data[${this.formField.slug}]`, null, false);
            this.onChangeHandler(`additional_data[${this.unitNumberKey}]`, this.unitNumberValue, true);
        },
        onUnitNumberInput(event) {
            this.unitNumberValue = event.target.value;
            this.onChangeHandler(`additional_data[${this.unitNumberKey}]`, this.unitNumberValue, true);
        },
    },

    mounted() {
        if (this.selectedFilters[`additional_data[${this.formField.slug}]`] ?? false) {
            this.value = decodeURIComponent(this.selectedFilters[`additional_data[${this.formField.slug}]`]).replaceAll('+', ' ');
        }

        if (this.selectedFilters[`additional_data[${this.unitNumberKey}]`] ?? false) {
            this.unitNumberValue = decodeURIComponent(this.selectedFilters[`additional_data[${this.unitNumberKey}]`]).replaceAll('+', ' ');
        }
    }
}
</script>
